import { render, staticRenderFns } from "./cardapio.vue?vue&type=template&id=39160dd2&scoped=true&"
import script from "./cardapio.vue?vue&type=script&lang=js&"
export * from "./cardapio.vue?vue&type=script&lang=js&"
import style0 from "./cardapio.vue?vue&type=style&index=0&id=39160dd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39160dd2",
  null
  
)

export default component.exports